import { Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { FormFieldCorrespondingAuthor } from '@publishing-engine/domain/types/article';
import { CorrespondingAuthorDisplay } from './CorrespondingAuthorDisplay';

interface Props {
  value?: string;
  previousValue?: string;
  onClose: () => void;
  config: FormFieldCorrespondingAuthor;
  authors?: any;
}

const zeroState = (
  <Flex
    flexDirection="row"
    justifyContent="space-between"
    backgroundColor="surfaceTertiaryFill"
    padding={4}
    color="neutralSecondaryContent"
  >
    <Flex alignItems="center" gap={2} flexDirection="row">
      <Text textStyle="textBody">No data available</Text>
    </Flex>
  </Flex>
);

export const CorrespondingAuthorDisplayDiffModal = ({
  value,
  previousValue,
  onClose,
  config,
  authors
}: Props) => {
  const label = config.params.labels.main;

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {!previousValue ? (
          zeroState
        ) : (
          <CorrespondingAuthorDisplay
            displayEmail={previousValue}
            authors={authors}
          />
        )}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {!value ? (
          zeroState
        ) : (
          <CorrespondingAuthorDisplay displayEmail={value} authors={authors} />
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
